import * as busyCounter from '../../../../sharedmodules/action-creators/busy-counter';
import actions from '../../../../sharedmodules/actions-list';
import { handleError } from '../../../../sharedmodules/services/error-handlers';
import { searchPinPlateRequests } from '../repositories/searchPinPlateRequests';

export const searchPinPlateData = (getAccessToken, data) => async (dispatch) => {

    dispatch(busyCounter.increaseBusyCounter());

    try {

        const pinPlateRequestData = await searchPinPlateRequests(getAccessToken, data);
        dispatch({
            data: pinPlateRequestData,
            type: actions.GET_PIN_PLATE_REQUEST_DATA,

        });

    } catch (error) {

        handleError(error);

    } finally {

        dispatch(busyCounter.decreaseBusyCounter());

    }

};
